import React, { memo } from 'react';
import styles from './card.module.scss';

export const Card = memo(({ title, image, link }) => {
  return (
    <div className={styles.card}>
      <a href={link} className={styles.link} target="_blank" rel="noopener noreferrer">
        <img src={image} alt='thumbnail' className={styles.image} />
        <div className={styles.contents}>
          <dl>
            <dt className={styles.title}>{title}</dt>
            {/* <dd className={styles.text}>{children}</dd> */}
          </dl>
        </div>
      </a>
    </div>
  );
});
